import { localCache } from '@/utils/cache'

const permissionHeader = () => {
  const header = {}

  const info = localCache.getCache('teamMessage') || {}

  if (info.ownerType == '1') {
    header['teamId'] = info.id
  } else if (info.ownerType == '2') {
    header['companyId'] = info.id
  }
  header['ownerType'] = info.ownerType || 0
  return header
}

export default permissionHeader
